import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {WicketApplication} from '@tisa-group/models/wicket/wicket-application';
import {map, Observable} from 'rxjs';
import {TISA_WICKET_DICTS_URL} from '../tisa-wicket.providers';

@Injectable({
  providedIn: 'root',
})
export class ApplicationsApiService {
  constructor(
    protected readonly httpClient: HttpClient,
    @Inject(TISA_WICKET_DICTS_URL) readonly wicketDictsUrl: string,
  ) {}

  fetchApplications(): Observable<WicketApplication[]> {
    return this.httpClient
      .get<{data: WicketApplication[]}>(
        `${this.wicketDictsUrl}/dictionaries/applications`,
      )
      .pipe(map(res => res.data));
  }
}
